import { useState } from "react";
import { Container, Row, Col } from "react-bootstrap";
import contactImg from "../assets/img/contact-img.svg";
import 'animate.css';
import TrackVisibility from 'react-on-screen';

export const Contact = () => {

  return (
    <div>
      <img src="https://i.pinimg.com/originals/df/41/07/df4107edd8b4fe79455810ea6222e087.gif" alt="eso"></img>
    </div>
  )
}
